import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import CustomRequestModal, { IDispatchProps, IProps } from './index';
import { ApplicationState } from '../../../../store';
import { closeModal } from '../../../../store/ui/actions';
import { requestCustomDoc } from '../../../../store/student/documents/actions';
import { requestCustomDoc as requestCustomFinanceDoc } from '../../../../store/student/financeDocuments/actions';
import { requestCustomFollowUpDoc } from '../../../../store/student/followUpDocuments/actions';
import { saveMessage } from '../../../../store/student/actions';
import { DocAccessType } from '../../../../types';
import { IMessage, SectionStatusType, IFollowUpArea } from 'api-paths-cas';
import { getDisplayName } from '../../../../utilities/formatting';
import { getAgentList } from '../../../../utilities/pages';

const mapStateToProps = (state: ApplicationState, ownProps: { followUpArea?: IFollowUpArea }): IProps => {
  return {
    userName: state.auth.student_number!,
    displayName: getDisplayName(state.auth, state.config),
    isFollowUpDoc: state.ui.openModal?.isFollowUpDocumentModal || false,
    isFinancialDoc: state.ui.openModal?.isFinanceDocumentModal || false,
    isBeforeArrivalAreaHidden:
      (state.student.config?.beforeArrivalDocAreaStatus === SectionStatusType.INACTIVE &&
        state.student.summary?.beforeTravelDocsRequired === 0) ??
      true,
    isAfterArrivalAreaHidden:
      (state.student.config?.afterArrivalDocAreaStatus === SectionStatusType.INACTIVE &&
        state.student.summary?.afterArrivalDocsRequired === 0) ??
      true,
    role: state.auth.role,
    hasAgent: (getAgentList(state.student.offer.assignedAgents) ?? []).length > 0,
    followUpArea: ownProps.followUpArea,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  onClose: () => dispatch(closeModal()),
  onSubmitMessage: (
    isFinancialDoc: boolean,
    isFollowUpDoc: boolean,
    message: IMessage,
    documentName: string,
    documentDescription: string,
    userAccess?: DocAccessType,
    followUpArea?: string,
  ) => {
    if (isFinancialDoc) {
      dispatch(requestCustomFinanceDoc(documentName, documentDescription, userAccess));
    } else if (isFollowUpDoc) {
      dispatch(requestCustomFollowUpDoc(documentName, documentDescription, followUpArea!, userAccess));
    } else {
      dispatch(requestCustomDoc(documentName, documentDescription, userAccess));
    }
    dispatch(saveMessage(message));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomRequestModal);
